import {
  Box,
  styled, TypographyProps,
} from '@mui/material';
import { kiwiGreen, sanguine } from '../../../../../../../../../../../../../utils/colors';

const StyledTypography = styled((props: TypographyProps) => {
  const { color, ...rest } = props;

  return <Box {...rest} />;
})(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '0px 8px 0px 4px',
  borderRadius: 4,
  color: kiwiGreen[100],
  backgroundColor: kiwiGreen[600],
  fontSize: 14,
  textTransform: 'uppercase',
  fontWeight: 700,

  '& > svg': {
    color: 'inherit',
    fontSize: 16,
    backgroundColor: 'inherit',
  },

  '&.error': {
    color: sanguine[100],
    backgroundColor: sanguine[600],
  },
  '&.smallIcon': {
    '& > svg': {
      fontSize: 14,
    },
  },
}));

export default StyledTypography;
